(function () {
  function getSlideVideos(slide) {
    if (!slide) return [];
    return Array.from(slide.querySelectorAll('.cd-swiper-video'));
  }

  function activateVideo(video) {
    if (!video) return;

    try {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.load();
    } catch (e) {}

    setTimeout(function () {
      try {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } catch (e) {}
    }, 60);
  }

  function deactivateVideo(video) {
    if (!video) return;
    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {}
  }

  function activateSlideMedia(slide) {
    getSlideVideos(slide).forEach(activateVideo);
  }

  function deactivateSlideMedia(slide) {
    getSlideVideos(slide).forEach(deactivateVideo);
  }

  function initSegmentedHero(container) {
    if (!container || container.dataset.cdHeroInitialized === 'true') return;
    container.dataset.cdHeroInitialized = 'true';

    var slides = Array.from(container.querySelectorAll('.cd-swiper-slide'));
    var dots = Array.from(container.querySelectorAll('.cd-swiper-dot'));

    if (!slides.length) return;

    var currentIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    if (currentIndex < 0) currentIndex = 0;

    var autoplayDelay = 10000;
    var autoplayTimer = null;
    var userInteracted = false;

    function setActiveSlide(index) {
      if (index < 0 || index >= slides.length || index === currentIndex) return;

      var oldSlide = slides[currentIndex];
      var newSlide = slides[index];

      deactivateSlideMedia(oldSlide);

      oldSlide.classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');

      currentIndex = index;

      newSlide.classList.add('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');

      activateSlideMedia(newSlide);
    }

    function goToSlide(index, isUserAction) {
      setActiveSlide(index);
      if (isUserAction) {
        userInteracted = true;
        stopAutoplay();
      }
    }

    function nextSlide(isUserAction) {
      var nextIndex = currentIndex + 1;
      if (nextIndex >= slides.length) nextIndex = 0;
      goToSlide(nextIndex, isUserAction);
    }

    function prevSlide(isUserAction) {
      var prevIndex = currentIndex - 1;
      if (prevIndex < 0) prevIndex = slides.length - 1;
      goToSlide(prevIndex, isUserAction);
    }

    function startAutoplay() {
      if (userInteracted || slides.length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        nextSlide(false);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(index)) goToSlide(index, true);
      });
    });

    if (slides.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var isSwiping = false;
      var swipeThreshold = 40;

      function onTouchStart(e) {
        if (!e.touches || e.touches.length !== 1) return;
        var touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        isSwiping = true;
      }

      function onTouchMove(e) {
        if (!isSwiping || !e.touches || e.touches.length !== 1) return;
        var touch = e.touches[0];
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;

        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          e.preventDefault();
        }
      }

      function onTouchEnd(e) {
        if (!isSwiping) return;
        isSwiping = false;

        var touch = e.changedTouches && e.changedTouches[0];
        if (!touch) return;

        var dx = touch.clientX - touchStartX;
        if (Math.abs(dx) > swipeThreshold) {
          if (dx < 0) nextSlide(true);
          else prevSlide(true);
        }
      }

      container.addEventListener('touchstart', onTouchStart, { passive: true });
      container.addEventListener('touchmove', onTouchMove, { passive: false });
      container.addEventListener('touchend', onTouchEnd);

      container.addEventListener('mouseenter', stopAutoplay);
      container.addEventListener('mouseleave', startAutoplay);
    }

    slides.forEach(function (slide, index) {
      if (index !== currentIndex) {
        deactivateSlideMedia(slide);
      }
    });

    activateSlideMedia(slides[currentIndex]);
    startAutoplay();
  }

  function initAllSegmentedHeroes() {
    document.querySelectorAll('.cd-segmented-hero').forEach(initSegmentedHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSegmentedHeroes);
  } else {
    initAllSegmentedHeroes();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.cd-segmented-hero');
    if (container) {
      delete container.dataset.cdHeroInitialized;
      initSegmentedHero(container);
    }
  });
})();